<div class="modal-card">
  <!-- Header -->
  <div class="modal-header">
    <div class="title-section">
      <mat-icon class="header-icon">assignment</mat-icon>
      <h2>{{ data.assignmentLinkName }} Invitation</h2>
    </div>

    <button class="close-btn" (click)="close()">✕</button>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <p class="description">
      Are you sure you want to send the invitation to
      <strong>{{ data.userName }}</strong
      >? An email containing the assessment details and access instructions will
      be sent to <strong>{{ data.userEmail }}</strong
      >.
    </p>

    <!-- Details Card -->
    <div class="details-box">
      <div class="detail-row">
        <span class="label">Assessment</span>
        <span class="value">{{ data.assignmentLinkName }}</span>
      </div>

      <div class="detail-row">
        <span class="label">Link</span>
        <span class="value url-text">
          {{ data.assignmentLinkUrl }}
        </span>
      </div>

      <div class="detail-row">
        <span class="label">Duration</span>
        <span class="value"> {{ getDuration(data.assessmentTimeLimit) }} </span>
      </div>

      <div class="detail-row">
        <span class="label">Expiry</span>
        <span class="value">
          {{ data.expiryDate | date: "MMM dd, yyyy" }}
        </span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="cancel-btn" (click)="close()">Cancel</button>

    <button class="btn-add" (click)="sendInvitation()">Send Invitation</button>
  </div>
</div>
